"use strict";
import React from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import classNames from "classnames";
import { observer } from "mobx-react";
export const StepCount = observer(
  ({ currentStep, totalSteps, goToAPreviousStep, raised = false }) => {
    return /* @__PURE__ */ React.createElement(TransitionGroup, { className: classNames("step-count", { "step-count--raised": raised }) }, new Array(totalSteps).fill(0).map((_, index) => /* @__PURE__ */ React.createElement(CSSTransition, { classNames: "step-count__step", timeout: 500, key: `step--${index}` }, /* @__PURE__ */ React.createElement("div", { className: "step-count__step-wrapper" }, index !== 0 && /* @__PURE__ */ React.createElement("div", { key: `line--${index}`, className: "step-count__line" }), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames("step-count__step", {
          "step-count__step--current": index === currentStep,
          "step-count__step--previous": index < currentStep
        }),
        onClick: () => {
          if (index < currentStep) {
            goToAPreviousStep(index);
          }
        }
      },
      index === currentStep && index + 1
    )))));
  }
);
